import { StorageItem } from '@models/enums';
import { Config } from '../config/config';
import { LocalStorageService } from './local-storage.service';

import themeColors from 'styles/theme/colors.module.scss';

export class ZohoService {
  private static _instance: ZohoService;
  private _localStorageService: LocalStorageService;
  private _zohoScriptId: string = 'zoho-script';

  private constructor() {
    this._localStorageService = new LocalStorageService();
  }

  static get get(): ZohoService {
    if (!this._instance) {
      this._instance = new ZohoService();
    }

    return this._instance;
  }

  inject(): void {
    window.ZohoHCAsapSettings = {
      userInfo: {
        token: `${this._localStorageService.getItem(StorageItem.ACCESS_TOKEN)}`,
      },
    };

    const zohoScript = document.createElement('script');

    zohoScript.setAttribute('id', this._zohoScriptId);
    zohoScript.setAttribute('type', 'text/javascript');
    zohoScript.setAttribute('src', Config.get().zohoSrc);
    zohoScript.setAttribute('defer', 'true');

    document.body.appendChild(zohoScript);

    this._overrideColorScheme();
  }

  remove(): void {
    delete window.ZohoHCAsapSettings;

    const zohoContainer = document.getElementById(
      'zohohc-asap-web-helper-main',
    );
    const zohoScript = document.getElementById(this._zohoScriptId);

    if (zohoContainer) {
      document.body.removeChild(zohoContainer);
    }

    if (zohoScript) {
      document.body.removeChild(zohoScript);
    }
  }

  private _overrideColorScheme(): void {
    new Promise((resolve: (element: HTMLElement) => void) => {
      const observer = new MutationObserver(() => {
        const zohoCSSVariables = document.getElementById(
          'zohohc-asap-web-cssvariables',
        );

        if (zohoCSSVariables) {
          resolve(zohoCSSVariables);
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }).then((element: HTMLElement) => {
      const overrideStyles = document.createElement('style');

      overrideStyles.setAttribute('id', 'override-styles');
      overrideStyles.innerHTML = `
            :root {
              --zohohc_asap_web_applauncher_bg: ${themeColors.zohoAccent};
              --zohohc_asap_web_appclose_iconbg: ${themeColors.zohoAccent};
              --zohohc_asap_web_apptabitem_selectedbg: ${themeColors.blue4};
              --zohohc_asap_web_apptabitem_iconclr: ${themeColors.fontColor};
              --zohohc_asap_web_apptabitem_selectedtextclr: ${themeColors.white};
              --zohohc_asap_web_appfootermenu_bg: ${themeColors.zohoAccent};
              --zohohc_asap_web_apppage_bg: ${themeColors.selectBackground};
              --zohohc_asap_web_appheader_bg: ${themeColors.blue5};
              --zohohc_asap_web_appsecondary_bg: ${themeColors.selectBackground};
              --zohohc_asap_web_appthemebase_bdr_clr: ${themeColors.zohoAccent};
              --zohohc_asap_web_appprimary_textclr: ${themeColors.white};
              --zohohc_asap_web_appaccent_clr: ${themeColors.zohoAccent};
              --zohohc_asap_web_appsecondary_textclr: ${themeColors.fontColor};
              --zohohc_asap_web_appthird_bgclr: ${themeColors.blue4};
              --zohohc_asap_web_appeditorhvr_bg: ${themeColors.blue4};
              --zohohc_asap_web_apppopupview_bg_clr: ${themeColors.selectBackground};
              --zohohc_asap_web_appbutton_primary_bg: ${themeColors.primary};
              --zohohc_asap_web_appthemebase_txtclr: ${themeColors.fontColor};
              --zohohc_asap_web_appthemedefault_bgclr: ${themeColors.blue3};
              --zohohc_asap_web_apploading_bg: ${themeColors.selectBackground};
            }

           input[data-id='product_name_search_input']::placeholder { color: ${themeColors.placeholder}; }
          `;

      element.parentNode?.insertBefore(overrideStyles, element.nextSibling);
    });
  }
}
